module.exports = __webpack_public_path__ + "img/gift-2.9cc1e59a.jpg";